/*
 * The DOM id of the empty slot `PortalHeader` and `MobileTopBar` each render
 * in their actions cluster, next to Help and the notifications bell.
 *
 * The TechDocs reader's settings control needs to render there, but it lives
 * deep inside the reader's own routed page tree — bound to
 * `TechDocsReaderProvider` context that only exists while a reader page is
 * mounted — while the header chrome is mounted once at the shell level,
 * outside and above that tree entirely. A shared id is the simplest bridge:
 * the reader-scoped addon portals its trigger into whichever slot node
 * currently exists (desktop or mobile; the shell renders exactly one), and
 * neither side needs to know anything about the other beyond this string.
 *
 * Only one producer (`PortalHeader` or `MobileTopBar`) is ever mounted at a
 * time — `PortalShell` picks one on the phone breakpoint — so a single id
 * never collides with itself.
 */
export const TECHDOCS_HEADER_SLOT_ID = 'techdocs-header-actions-slot';
